/**
 * Parcels: any authenticated member can create and view all.
 * Update/delete: record owner (created_by), Team Leader, or Purchasing bureau (bureau_id 5). Admins/treasurers are not elevated.
 */

export function canModifyParcel(user, parcel) {
  if (!user || !parcel) return false;
  const isOwner = Number(parcel.created_by) === Number(user.id);
  const isTL = Boolean(user.is_team_leader) || Number(user.management_id) === 1;
  const isPurchasing = Number(user.bureau_id) === 5;
  return isOwner || isTL || isPurchasing;
}

export function canSetParcelWorkflowOnCreate(user) {
  // Keep create/edit behavior consistent: any authenticated member
  // who can create a parcel should be able to set receiver/workflow data.
  return Boolean(user);
}

/** User may archive a parcel (authorized; not already archived). */
export function canArchiveParcel(user, parcel) {
  if (!canModifyParcel(user, parcel)) return false;
  return !parcel?.archived_at;
}
